<template>
    <div>
        <div class="card b-all shadow-none">
            <div class="card-body">

                <div class="table-filters">
                    <div class="row justify-content-between">
                        <div class="col-md-12">
                            <div class="form-inline">
                                <div class="input-group mt-1 mr-1">
                                    <input type="text"
                                           v-model="filterText"
                                           @keyup.enter="doFilter"
                                           placeholder="Search SMSs"
                                           class="form-control">
                                    <div class="input-group-append">
                                        <button class="btn btn-primary" type="button" @click="doFilter">
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="inbox-center table-responsive" :class="{'table-loading' : isLoadingTableData}">

                    <vuetable ref="smsVuetable"
                              api-url="/sms"
                              :fields="columns"
                              class="table"
                              :css="css.table"
                              pagination-path=""
                              :per-page="20"
                              :append-params="searchParams"
                              no-data-template="You haven't sent any SMSs yet!"
                              @vuetable:loading="onLoading"
                              @vuetable:loaded="onLoaded"
                              @vuetable:pagination-data="onPaginationData">

                        <div slot="message" slot-scope="props" class="inline">
                            <span v-if="props.rowData.status == 'failed'" class="label label-sm label-light-danger"
                                  :title="props.rowData.failure_reason">Failed</span>
                            <span>{{ props.rowData.body }}</span>
                        </div>

                        <template slot="actions" slot-scope="props">
                            <div class="table-button-container">
                                <button class="btn btn-rounded btn-outline-primary btn-sm"
                                        @click="onActionClick('view-sms', props.rowData)">
                                    View
                                </button>
                            </div>
                        </template>

                    </vuetable>

                    <vuetable-pagination-info ref="smsPaginationInfo" no-data-template=""></vuetable-pagination-info>

                    <div class="text-right">
                        <vuetable-pagination ref="smsPagination"
                                             @vuetable-pagination:change-page="onChangePage"
                        ></vuetable-pagination>
                    </div>

                </div>
            </div>
        </div>
        <view-sms :sms="selectedSMS" :show="viewSMS" v-on:close-sms-form="closeSmsForm()"></view-sms>
    </div>
</template>

<script>
export default {

    name: "sms-messages",

    mixins: [require("../../mixins/vuetable-css-mixin")],

    data () {
        return {
            filterText: "",
            searchParams: {},
            isLoadingTableData: false,
            selectedSMS: {},
            viewSMS: false,
            columns: [
                {
                    name: "to",
                    title: "To",
                    titleClass: "email-from-column-header"
                },
                {
                    name: "__slot:message",
                    title: "Message",
                    dataClass: "email-subject-column truncate",
                    titleClass: "email-subject-column"
                },
                {
                    name: "created_at",
                    title: "Sent At",
                    titleClass: "email-updated-at-column",
                },
                {
                    name: "__slot:actions",
                    title: "",
                    titleClass: "text-right email-actions-column",
                    dataClass: "text-right"
                }
            ],
        };
    },

    mounted () {
        this.css.table.tableClass = "table table-fixed";
    },

    methods: {

        onActionClick (action, data, index) {
            switch (action) {
                case "view-sms":
                    this.showSMS(data);
                    break;
            }
        },

        showSMS (sms) {
            this.selectedSMS = sms;
            this.viewSMS = true;
        },

        closeSmsForm () {
            this.viewSMS = false;
            this.selectedSMS = {};
        },

        onPaginationData (paginationData) {
            this.$refs.smsPagination.setPaginationData(paginationData);
            this.$refs.smsPaginationInfo.setPaginationData(paginationData);
        },

        onChangePage (page) {
            this.$refs.smsVuetable.changePage(page);
        },

        reloadTable () {
            Vue.nextTick(() => this.$refs.smsVuetable.refresh());
        },

        doFilter () {
            this.searchParams = {
                "filter": this.filterText
            };
            this.reloadTable();
        },

        onLoading () {
            this.isLoadingTableData = true;
        },

        onLoaded () {
            this.isLoadingTableData = false;
        }

    }

};
</script>

<style scoped>

</style>
